import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * On every route change, scroll the window to the top.
 * Drop-in component — render it once inside <BrowserRouter>.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // 'instant' instead of 'smooth' for snappier UX during fast nav
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
